import type { MetaFunction } from 'react-router';
import { MicroLandingNew } from '~/components/ProductMicroLanding';
import ExcelGlory from '~/assets/excel-glory.svg';
import { generateMeta } from '~/services/meta';
import ExcelHowTo from '~/assets/excel-online.png';

export const meta: MetaFunction = () => {
    return generateMeta({
        title: 'ChatGPT add-in for Excel',
        description: `Use ChatGPT directly inside Excel to write formulas, analyze data, and fix errors — all without leaving your spreadsheet. No copy-pasting, no tabs. Fully native add-in. Try it free today.`,
    });
};

export default () => (
    <MicroLandingNew
        hero={{
            imgUrl: ExcelGlory,
            title: 'ChatGPT plugin for Excel',
            subTitle:
                'Generate formulas, simplify complex tasks, and analyze data instantly — without leaving Microsoft Excel',
            productName: 'Excel',
            features: [
                '✅ Generate and fix formulas — instantly',
                '📊 Analyze and summarize data in seconds',
                '🕒 Save hours on spreadsheets every week',
                '🔁 Stay inside Excel — no switching tabs',
            ],
            samplePrompts: ['generate-excel-formula', `explain-excel-formula`],
            feedback: {
                message:
                    'This AI Assistant completely transformed how I work in Excel. It helps me build complex formulas and understand data faster — it’s like having an expert at my side',
                name: 'Alisa Campbell',
                role: 'Data Analyst at WaveRock',
            },
            install: [
                {
                    label: 'Install for Excel App',
                    url: '/chatgpt-for-microsoft-excel/install/desktop',
                },
                {
                    label: 'Install for Excel Online',
                    url: '/chatgpt-for-microsoft-excel/install/online',
                },
            ],
        }}
        instruction={{
            title: 'How it works inside Excel?',
            demoEl: (
                <div
                    style={{
                        position: 'relative',
                        paddingTop: '56.25%',
                    }}>
                    <iframe
                        title={`ChatGPT for Excel`}
                        src={
                            'https://www.youtube-nocookie.com/embed/2qzr_tAIfO0?si=iyeCItkIK3ZIjb7i'
                        }
                        loading='lazy'
                        style={{
                            border: 'none',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                        }}
                        allow='accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;'
                        allowFullScreen
                    />
                </div>
            ),
            steps: [
                <>
                    <b>Open Excel:</b> Highlight any cell of the spreadsheet in
                    Microsoft Excel document
                </>,
                <>
                    <b>Use AI Perfect Assistant:</b> Open AI Perfect Assistant,
                    select any AI Prompt Template and Click "Generate with AI"
                </>,
                <>
                    <b>Insert result to the spreadsheet:</b> Click "Insert" to
                    insert AI generated text to the Excel spreadsheet
                </>,
            ],
        }}
    />
);
